import {
  ADD_ARTICLE,
  SET_SEARCH_WORD,
  SET_ACTIVE_FILTERS,
  SET_PRODUCTS,
  SET_FILTERS,
  SET_RESULTS_COUNT,
  SET_PAGE,
  SET_PAGES,
  SET_SUGGESTED_WORDS,
  SET_DEFAULT_NO_CATEGORIES,
  SET_SLIDER_VALUE_MIN_MAX,
  SET_SLIDER_VALUE,
  SET_MASTER_CATEGORIES,
  SET_SEARCH_URL,
  SET_DEFAULT_MASTER_CATEGORIES,
  SET_SORT,
  SET_DEFAULT_CATEGORIES,
  SET_PREV_PRODUCTS,
  SET_LAST_UPDATE,
  SET_FILTERS_NO_FILTER,
  SET_URL_PREFIX,
  SET_AUTOCOMPLETE_CATEGORIES_OPTIONS,
  SET_AUTOCOMPLETE_OPTIONS,
  SET_IS_EXPANDED,
  SET_IMG_PREFIX,
  SET_IS_FROM_HALF_SCREEN,
  SET_ADVANCED_CUSTOMIZATION,
  SET_ASYNC_DATA,
  SET_LISTING_BANNER,
  SET_CONFIG,
  SET_FILTERS_NO_PRICE,
  SET_IS_MOBILE,
  SET_SHOW_FILTERS,
  SET_WORDS_HISTORY,
  SET_IS_SEARCHING,
  SET_IS_AUTOCOMPLETE_OPEN,
  SET_SHOW_OVERLAY,
  SET_URL_QUERY,
  SET_URL_FILTERS,
  SET_SEO_SETTINGS,
} from "../constants/action-types";
import Utils from "../../utils/Utils";

const initialState = {
  articles: [],
  searchWord: "",
  activeFilters: [],
  masterCategories: [],
  defaultMasterCategories: [],
  wordsHistory: [],
  products: [],
  prevProducts: [],
  filters: [],
  seoSettings: {
    isActive: true,
    searchWord: "search",
  },
  defaultCategories: [],
  sort: null,
  resultsCount: 0,
  searchUrl: "",
  page: 1,
  ga4: { isActive: false },
  pages: [],
  suggestedWords: [],
  mostSearched: ["Shoes", "Jacket", "Shirt"],
  sliderValue: [0, 1],
  sliderValueMinMax: [0, 1],
  config: { ...Utils.DUMMY_CONFIG },
  isMobile: false,
  showFilters: false,
  isSearching: false,
  isAutocompleteOpen: false,
  showOverlay: false,
  lastUpdate: "",
  urlPrefix: "",
  imgPrefix: "",
  autocompleteOptions: [],
  autocompleteCategoriesOptions: [],
  isExpanded: {},
  isFromHalfScreen: false,
  advancedCustomization: {},
  asyncData: [],
  listingBanner: {},
  urlQuery: "",
  urlFilters: [],
};

export default function rootReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ARTICLE:
      return { ...state, articles: state.articles.concat(action.payload) };
    //   return Object.assign({}, state, {
    //     articles: state.articles.concat(action.payload),
    //   });
    case SET_SEARCH_WORD:
      //   return Object.assign({}, state, {
      //     searchWord: action.payload,
      //   });
      return { ...state, searchWord: action.payload };
    case SET_CONFIG:
      return { ...state, config: action.payload };
    //   return Object.assign({}, state, {
    //     config: action.payload,
    //   });
    case SET_IS_AUTOCOMPLETE_OPEN:
      return Object.assign({}, state, {
        isAutocompleteOpen: action.payload,
      });
    case SET_ASYNC_DATA:
      return {
        ...state,
        asyncData: action.payload,
      };
    case SET_WORDS_HISTORY:
      return { ...state, wordsHistory: action.payload };
    //   return Object.assign({}, state, {
    //     wordsHistory: action.payload,
    //   });
    case SET_SHOW_OVERLAY:
      return { ...state, showOverlay: action.payload };
    //   return Object.assign({}, state, {
    //     showOverlay: action.payload,
    //   });
    case SET_ACTIVE_FILTERS:
      return { ...state, activeFilters: action.payload };
    //   return Object.assign({}, state, {
    //     activeFilters: action.payload,
    //   });
    case SET_IS_SEARCHING:
      return { ...state, isSearching: action.payload };
    //   return Object.assign({}, state, {
    //     isSearching: action.payload,
    //   });
    case SET_LAST_UPDATE:
      return { ...state, lastUpdate: action.payload };
    //   return Object.assign({}, state, {
    //     lastUpdate: action.payload,
    //   });
    case SET_AUTOCOMPLETE_OPTIONS:
      return { ...state, autocompleteOptions: action.payload };
    //   return Object.assign({}, state, {
    //     autocompleteOptions: action.payload,
    //   });
    case SET_ADVANCED_CUSTOMIZATION:
      return { ...state, advancedCustomization: action.payload };
    //   return Object.assign({}, state, {
    //     advancedCustomization: action.payload,
    //   });
    case SET_AUTOCOMPLETE_CATEGORIES_OPTIONS:
      return { ...state, autocompleteCategoriesOptions: action.payload };
    //   return Object.assign({}, state, {
    //     autocompleteCategoriesOptions: action.payload,
    //   });
    case SET_PRODUCTS:
      return { ...state, products: Object.values(action.payload) };
    //   return Object.assign({}, state, {
    //     products: Object.values(action.payload),
    //   });
    case SET_PREV_PRODUCTS:
      return { ...state, prevProducts: Object.values(action.payload) };
    //   return Object.assign({}, state, {
    //     prevProducts: Object.values(action.payload),
    //   });
    case SET_FILTERS:
      return { ...state, filters: Utils.extractFilters(action.payload) };
    //   return Object.assign({}, state, {
    //     filters: Utils.extractFilters(action.payload),
    //   });
    case SET_DEFAULT_NO_CATEGORIES:
      return {
        ...state,
        defaultCategories: Utils.extractFiltersWithoutCategories(
          state.filters,
          action.payload
        ),
      };
    //   return Object.assign({}, state, {
    //     filters: Utils.extractFiltersWithoutCategories(
    //       state.filters,
    //       action.payload
    //     ),
    //   });
    case SET_FILTERS_NO_PRICE:
      return {
        ...state,
        filters: Utils.extractFiltersWithoutPrice(
          state.filters,
          action.payload
        ),
      };
    //   return Object.assign({}, state, {
    //     filters: Utils.extractFiltersWithoutPrice(
    //       state.filters,
    //       action.payload
    //     ),
    //   });
    case SET_FILTERS_NO_FILTER:
      return {
        ...state,
        filters: Utils.extractFiltersWithoutFilter(
          state.filters,
          action.payload
        ),
      };
    //   return Object.assign({}, state, {
    //     filters: Utils.extractFiltersWithoutFilter(
    //       state.filters,
    //       action.payload
    //     ),
    //   });
    case SET_IS_FROM_HALF_SCREEN:
      return { ...state, isFromHalfScreen: action.payload };
    //   return Object.assign({}, state, {
    //     isFromHalfScreen: action.payload,
    //   });
    case SET_URL_PREFIX:
      return { ...state, urlPrefix: action.payload };
    //   return Object.assign({}, state, {
    //     urlPrefix: action.payload,
    //   });
    case SET_IMG_PREFIX:
      return { ...state, imgPrefix: action.payload };
    //   return Object.assign({}, state, {
    //     imgPrefix: action.payload,
    //   });
    case SET_LISTING_BANNER:
      return { ...state, listingBanner: action.payload };
    //   return Object.assign({}, state, {
    //     listingBanner: action.payload,
    //   });
    case SET_IS_EXPANDED:
      return { ...state, isExpanded: action.payload };
    //   return Object.assign({}, state, {
    //     isExpanded: action.payload,
    //   });
    case SET_DEFAULT_CATEGORIES:
      return { ...state, defaultCategories: action.payload };
    //   return Object.assign({}, state, {
    //     defaultCategories: action.payload,
    //   });
    case SET_RESULTS_COUNT:
      return { ...state, resultsCount: action.payload };
    //   return Object.assign({}, state, {
    //     resultsCount: action.payload,
    //   });
    case SET_SHOW_FILTERS:
      return { ...state, showFilters: action.payload };
    //   return Object.assign({}, state, {
    //     showFilters: action.payload,
    //   });
    case SET_MASTER_CATEGORIES:
      return { ...state, masterCategories: action.payload };
    //   return Object.assign({}, state, {
    //     masterCategories: action.payload,
    //   });
    case SET_SEARCH_URL:
      return { ...state, searchUrl: action.payload };
    //   return Object.assign({}, state, {
    //     searchUrl: action.payload,
    //   });
    case SET_IS_MOBILE:
      return { ...state, isMobile: action.payload };
    //   return Object.assign({}, state, {
    //     isMobile: action.payload,
    //   });
    case SET_DEFAULT_MASTER_CATEGORIES:
      return { ...state, defaultMasterCategories: action.payload };
    //   return Object.assign({}, state, {
    //     defaultMasterCategories: action.payload,
    //   });
    case SET_SORT:
      return { ...state, sort: action.payload };
    //   return Object.assign({}, state, {
    //     sort: action.payload,
    //   });
    case SET_PAGE:
      return { ...state, page: action.payload };
    //   return Object.assign({}, state, {
    //     page: action.payload,
    //   });
    case SET_PAGES:
      return { ...state, pages: action.payload };
    //   return Object.assign({}, state, {
    //     pages: action.payload,
    //   });
    case SET_SUGGESTED_WORDS:
      return { ...state, suggestedWords: action.payload ? action.payload : [] };
    //   return Object.assign({}, state, {
    //     suggestedWords: action.payload ? action.payload : [],
    //   });
    case SET_SLIDER_VALUE:
      return { ...state, sliderValue: action.payload };
    //   return Object.assign({}, state, {
    //     sliderValue: action.payload,
    //   });
    case SET_SLIDER_VALUE_MIN_MAX:
      return { ...state, sliderValueMinMax: action.payload };
    //   return Object.assign({}, state, {
    //     sliderValueMinMax: action.payload,
    //   });
    case SET_URL_QUERY:
      return { ...state, urlQuery: action.payload };
    case SET_URL_FILTERS:
      return {
        ...state,
        urlFilters: state.urlFilters
          ? [...state.urlFilters, action.payload]
          : [],
      };
    case SET_SEO_SETTINGS:
      return {
        ...state,
        seoSettings: action.payload,
      };
    default:
      return state;
  }
}
